var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid modal-comment__container" }, [
    _c(
      "div",
      {
        staticClass: "grid__col--2 modal-comment__icon-container h-center-align"
      },
      [
        _vm.author.headshot
          ? _c("div", { staticClass: "modal-comment__icon" }, [
              _c("img", {
                staticClass: "modal-comment__icon-image",
                attrs: { src: _vm.author.headshot }
              })
            ])
          : _c("div", {
              staticClass:
                "modal-comment--blank modal-comment__icon modal-comment__icon--blank"
            })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "grid__col--10 h-no-padding modal-comment__text-container"
      },
      [
        _c("div", { staticClass: "modal-comment__author" }, [
          _vm._v(_vm._s(_vm.author.fullName))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-comment__datetime" }, [
          _vm._v(
            _vm._s(_vm.displayDate(_vm.comment.created_time, "MM/DD/YYYY"))
          )
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "modal-comment__content",
          domProps: { innerHTML: _vm._s(_vm.comment.note) }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }